import { StateCreator } from 'zustand';

import { DeductionsConfigurations } from '@aslanpay/portal-common-lib';

import { PayCalendarFormFields } from 'app/components/PayCalendars/CreatePayCalendar/CreatePayCalendarForm/types';

import { CreatePayCalendarSlice } from './types';

const initialState: PayCalendarFormFields = {
  name: '',
  currency: 'GBP',
  payFrequency: 'MONTHLY',
  payType: 'IN_PERIOD',
  paydayNDayOfPeriod: undefined, // value for nth day of period
  paydayNBusinessDayOfPeriod: undefined, // value for nth business day of period
  payday: undefined,
  paydayLastCustomWeekday: undefined,
  paydayFirstCustomWeekday: undefined, // NEW: First custom weekday for payday
  startDate: '',
  paydayNonBusinessDayFailover: 'NO_CHANGE', // how to handle weekends and bank holidays
  workingDays: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'],
  location: undefined,
  defaultAnnualGrossSalary: undefined,
  payrollCutoff: 'N_DAYS_BEFORE_PAYDAY',
  payrollCutoffDays: 3,
  payrollCutoffCustomDay: 0,
  cutOffNonBusinessDayFailover: 'NO_CHANGE',
  payrollCutoffFixedDay: undefined, // dd/mm/yyyy for fixed day
  customOdpAllowancePercentage: undefined,
  startingBalanceDays: undefined,
  odpAllowancePercentage: undefined,
  paydayFixedDay: undefined,
  accrualPeriod: undefined, // NEW: Accrual period configuration
  salariedDeductionsRequestMadeAvailableConfig:
    'DEDUCTIONS_PAY_CYCLE_PAYDAY' as DeductionsConfigurations, // NEW: Salaried deductions config
  nonSalariedDeductionsRequestMadeAvailableConfig:
    'DEDUCTIONS_PAY_CYCLE_PAYDAY' as DeductionsConfigurations, // NEW: Non-salaried deductions config
  customGlobalAllowancePercentage: 1, // NEW: Custom Global limit when it equals 200
  globalAllowancePercentage: 50,
};

const createPayCalendarSlice: StateCreator<CreatePayCalendarSlice> = (set) => ({
  payCalendarData: initialState,
  setPayCalendarData(payCalendarData) {
    set((state) => ({ payCalendarData: { ...state.payCalendarData, ...payCalendarData } }));
  },

  resetPayCalendarData() {
    set({ payCalendarData: initialState });
  },
});

export default createPayCalendarSlice;
